import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SegmentCMOSService } from 'src/app/services/segment-cmos.service';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { ApiV1Review } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-review-section',
  templateUrl: './review-section.component.html',
  styleUrls: ['./review-section.component.scss'],
})
export class ReviewSectionComponent implements OnInit {

  @Input() jobExternalId: string;
  @Input() reviews: Array<ApiV1Review>;
  @Input() maxReviewsDisplayed: number = 3;

  constructor(private readonly navCtrl: NavController,
              private readonly segmentCMOS: SegmentCMOSService) { }

  ngOnInit() {}

  getNumStars(): number {
    return Math.round(this.getAverageReviewScore(this.reviews));
  }

  getAverageReviewScore(reviews: Array<ApiV1Review>): number {
    let totalScore = reviews.reduce(function(prev, cur) {
      return prev + cur.starRating;
    }, 0);
    return Math.round(totalScore / reviews.length * 10) / 10; // truncate to single decimal place
  }

  async openAllReviews() {
    this.segmentCMOS.addEvent('moreReviewsButton_clickedFromJobDetailPage', { jobId: this.jobExternalId });
    await this.navCtrl.navigateForward(`${AppRoutingUtil.getPositionJobRoute(this.jobExternalId)}/reviews`, {
      state: {
        reviews: this.reviews
      }
    });
  }

}
